import * as yup from "yup";

export const salesRepDetails = yup.object({
  firstName: yup
    .string()
    .required("First Name is required")
    .min(2, "First Name must be at least 2 characters")
    .max(50, "First Name cannot exceed 50 characters")
    .matches(
      /^[a-zA-Z\s.'-]+$/,
      "First Name can only contain letters, spaces, period (.), apostrophe ('), and hyphen (-)"
    ),
  lastName: yup
    .string()
    .optional()
    .max(50, "Last Name cannot exceed 50 characters")
    .matches(
      /^[a-zA-Z\s.'-]*$/,
      "Last Name can only contain letters, spaces, period (.), apostrophe ('), and hyphen (-)"
    ),
  email: yup
    .string()
    .required("Email is required")
    .matches(
      /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/,
      "Please enter a valid email address"
    ),
});
